import { render, staticRenderFns } from "./hd_banner.vue?vue&type=template&id=5b37dadd&scoped=true"
import script from "./hd_banner.vue?vue&type=script&lang=js"
export * from "./hd_banner.vue?vue&type=script&lang=js"
import style0 from "./hd_banner.vue?vue&type=style&index=0&id=5b37dadd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37dadd",
  null
  
)

export default component.exports